export default {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 3000,
    background: 'rgba(0,0,0,.54)',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    opacity: 1,
    transform: 'translate3d(0px, 0px, 0px)'
  },
  close: {
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  container: {
    minWidth: 380,
    minHeight: 80,
    maxWidth: 600,
    maxHeight: '80%',
    display: 'flex',
    flexFlow: 'column',
    overflow: 'scroll',
    position: 'relative',
    zIndex: '1500',
    outline: 'none',
    borderRadius: '2px',
    boxShadow:
      '0 7px 9px -4px rgba(0, 0, 0, .2), 0 14px 21px 2px rgba(0, 0, 0, .14), 0 5px 26px 4px rgba(0, 0, 0, .12)',
    background: '#fff'
  },
  content: {
    padding: 24,
    flex: 1,
    flexBasis: 'auto',
    overflow: 'auto',
    position: 'relative',
    fontSize: 14
  },
  header: {
    fontWeight: 900,
    fontSize: 16
  },
  actions: {
    minHeight: '52px',
    padding: '8px 8px 8px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative'
  }
}



// WEBPACK FOOTER //
// ./src/components/common/dialog/common/styles.js